import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';
// slices
import eventReducer from './slices/event';
import actualitesReducer from './slices/actualites';
import documentsReducer from './slices/documents';
import newslettersReducer from './slices/newsletters'




// ----------------------------------------------------------------------

const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: [],
};  

const rootReducer = combineReducers({
  events: eventReducer,
  actualites: actualitesReducer,
  documents: documentsReducer,
  newsletters: newslettersReducer,
});

export { rootPersistConfig, rootReducer };
